import propTypes from 'prop-types';
import { useRef } from 'react';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

export default function Slider({ slides }) {
	const swiperPaginationRef = useRef(null);
	const swiperNextBtnRef = useRef(null);
	const swiperPrevBtnRef = useRef(null);

	return (
		<div>
			<Swiper
				loop={true}
				modules={[Navigation, Pagination]}
				navigation={{ nextEl: swiperNextBtnRef.current, prevEl: swiperPrevBtnRef.current }}
				pagination={{ clickable: true, el: swiperPaginationRef.current }}
				spaceBetween={32}
			>
				{slides.map((slide, i) => {
					return <SwiperSlide key={i}>{slide}</SwiperSlide>;
				})}
				<div className="prc-swiper__nav">
					<button className="prev" ref={swiperPrevBtnRef} />
					<div className="swiper-pagination" ref={swiperPaginationRef}></div>
					<button className="next" ref={swiperNextBtnRef} />
				</div>
			</Swiper>
		</div>
	);
}

Slider.propTypes = {
	slides: propTypes.array.isRequired,
};
